<template>
  <div class="bannerManage">
    <div class="bannerManage-main">
      <div class="header-btns">
        <div class="btns">
          <div class="btn" :class="current === 1 ? 'btn-active' : ''" @click="checkoutStatus(1)">
            已发布
          </div>
          <div class="btn" :class="current === 2 ? 'btn-active' : ''" @click="checkoutStatus(2)">
            已下线
          </div>
        </div>
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          @click="opAddOrEdit('add')"
        >
          添加视频
        </el-button>
      </div>
      <div class="bannerManage-main-contain">
        <el-form
          ref="subjectSearchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="视频名称：" prop="videoName">
            <el-input
              v-model="searchForm.videoName"
              style="width:250px"
              placeholder="输入视频名称可查询"
              maxlength="100"
              name="videoName"
              size="medium"
              class="edit-form-input"
            />
          </el-form-item>
          <el-form-item label="发布时间" prop="dateValue">
            <el-date-picker
              v-model="dateValue"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item label="视频类型" prop="videoType">
            <el-select
              v-model="searchForm.videoType"
              name="Terminal"
              size="medium"
              class="edit-form-input"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in videoTypeArr"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left:50px;">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="videoList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="50" align="center" label="序号" />
          <!-- <el-table-column label="PC视频封面" align="center" width="100" prop="dvdImgUrl">
            <template slot-scope="scope">
              <img :src="scope.row.dvdPcImgUrl" height="24" />
            </template>
          </el-table-column>
          <el-table-column
            label="PC封面格式"
            align="center"
            prop="dvdPcImgFormat"
            width="100"
            show-overflow-tooltip
          />
          <el-table-column label="PC封面大小" prop="dvdPcImgSize" width="100" show-overflow-tooltip /> -->
          <el-table-column label="视频封面" align="center" prop="dvdImgUrl">
            <template slot-scope="scope">
              <img :src="scope.row.dvdImgUrl" height="24">
            </template>
          </el-table-column>
          <el-table-column label="封面格式" align="center" prop="dvdImgFormat" show-overflow-tooltip />
          <el-table-column label="封面大小" prop="dvdImgSize" show-overflow-tooltip />
          <el-table-column label="视频名称" prop="dvdName" width="134" show-overflow-tooltip />
          <el-table-column label="视频分类" prop="dvdTypeName" show-overflow-tooltip />
          <!-- <el-table-column label="视频分类" prop="dvdName" width="134" show-overflow-tooltip>
            <template slot-scope="scope">
            <span v-show="scope.row.dvdType === 0">学习实例</span>
            <span v-show="scope.row.dvdType === 1">抖音剧场</span>
            <span v-show="scope.row.dvdType === 2">课桌安装</span>
            </template>
          </el-table-column> -->
          <el-table-column label="视频编号" prop="dvdNo" width="100" show-overflow-tooltip />
          <el-table-column label="视频格式" prop="dvdFormat" width="80" show-overflow-tooltip />
          <el-table-column label="视频大小" prop="dvdSize" width="80" show-overflow-tooltip />
          <el-table-column
            label="发布时间"
            prop="issueDate"
            align="center"
            width="160"
            show-overflow-tooltip
          />
          <el-table-column label="操作" align="center" width="360">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="opAddOrEdit('edit', scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-show="scope.row.issueStatus === 2"
                type="warning"
                size="small"
                @click="handlePublish('up', scope.row)"
              >
                上线
              </el-button>
              <el-button
                v-show="scope.row.issueStatus === 1"
                type="warning"
                size="small"
                @click="handlePublish('down', scope.row)"
              >
                下线
              </el-button>
              <el-button
                type="danger"
                size="small"
                icon="el-icon-delete"
                @click="handleDdelete(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <!-- 新增编辑视频 -->
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      top="8"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="handleTitle"
      width="650px"
      class="dialog"
    >
      <el-form
        ref="handleForm"
        :model="handleForm"
        :rules="handleRules"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="视频名称：" prop="videoName">
          <el-input
            v-model="handleForm.videoName"
            name="videoName"
            placeholder="请输入视频名称"
            class="handle-form-input"
            maxlength="30"
          />
        </el-form-item>
        <el-form-item label="视频编号：" prop="videoNumber">
          <el-input
            v-model="handleForm.videoNumber"
            oninput="value=value.replace(/[^\d]/g,'')"
            name="videoNumber"
            placeholder="请输入视频编号"
            class="handle-form-input"
            maxlength="5"
          />
        </el-form-item>
        <el-form-item label="视频类型：" prop="videoType">
          <el-select
            v-model="handleForm.videoType"
            name="videoType"
            size="medium"
            class="handle-form-input"
          >
            <el-option
              v-for="item in videoTypeArr"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <div style="display:flex">
          <!-- <el-form-item label="PC视频封面：" prop="dvdPcImgUrl" ref="dvdPcImgUrl">
            <div class="handle-form-input">
              <upload-file
                @uploadSucess="uploadSucessFnPC"
                @imgSize="imgSizePC"
                :props="{
                  serveCode: 'desk_video_img',
                  accept: '.png, .jpg, .jpeg',
                  type: ['image/jpeg', 'image/gif', 'image/png']
                }"
              >
                <el-button size="small" class="upload-btn" type="primary">选 择</el-button>
              </upload-file>
              <span
              class="explain"
                >文件选择JPG、PNG <br />类型上传请按照16/9<br />
                的尺寸上传，建议尺
                <br />
                寸1080*1920。
              </span>
            </div>
            <div class="picture-wrapper">
              <img v-if="dvdPcImgUrl && dvdPcImgUrl.length < 1" src="" alt="" />
              <el-image
                class="img"
                v-else
                @click.stop="handleClickItem"
                :src="dvdPcImgUrl"
                :preview-src-list="dvdPcImgUrlList"
              ></el-image>
            </div>
          </el-form-item> -->
          <el-form-item ref="videoImg" label="手机视频封面：" prop="videoImg">
            <div class="handle-form-input">
              <upload-file
                :props="{
                  serveCode: 'desk_video_img',
                  accept: '.png, .jpg, .jpeg',
                  type: ['image/jpeg', 'image/gif', 'image/png']
                }"
                @uploadSucess="uploadSucessFn"
                @imgSize="imgSize"
              >
                <el-button size="small" class="upload-btn" type="primary">
                  选 择
                </el-button>
              </upload-file>
              <span
                class="explain"
              >文件选择JPG、PNG <br>类型上传请按照16/9<br>
                的尺寸上传，建议尺
                <br>
                寸398*224。
              </span>
            </div>
            <div class="picture-wrapper">
              <img v-if="videoImg.length < 1" src="" alt="">
              <el-image
                v-else
                class="img"
                :src="videoImg"
                :preview-src-list="videoImgList"
                @click.stop="handleClickItem"
              />
            </div>
          </el-form-item>
        </div>
        <el-form-item ref="videoUrl" label="上传视频：" prop="videoUrl">
          <div class="handle-form-input">
            <upload-file
              :props="{ serveCode: 'desk_video', accept: '.mp4', type: ['video/mp4'], isMp4: true }"
              @uploadSucess="uploadVideo"
              @progress="progress"
              @typeError="typeError"
            >
              <el-button :loading="videoLoading" size="small" class="upload-btn" type="primary">
                {{
                  videoLoading ? 'Loading' : '选 择'
                }}
              </el-button>
            </upload-file>
            <span
              class="explain"
            >文件选择mp4类型且视频编码只能为H.264类型，上传文件大小不超过500MB</span>
            <span v-show="videoUrl" class="update-ok">
              <i class="el-icon-success" /> 上传成功
            </span>
          </div>
          <div class="picture-wrapper">
            <video
              :class="videoUrl ? 'video' : ''"
              :src="videoUrl"
              height="100%"
              @click="playVideo"
            />
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          :loading="ajaxLoading"
          class="footer-btn"
          type="primary"
          size="medium"
          @click="handleAddSubject"
        >
          {{ ajaxLoading ? 'Loading' : '发布' }}
        </el-button>
        <el-button size="medium" class="footer-btn" @click="handleClose">
          取消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog class="dialog-play" :visible.sync="dialogPlay" width="30%" :before-close="close">
      <video
        id="videoPlay"
        ref="dialogVideo"
        :src="videoUrl"
        controls
        class="video"
        width="100%"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// 获取API
import {
  getVideoList,
  getVideoAdd,
  getVideoEdit,
  getVideoDelete,
  getVideoType
} from '@/api/productOperation/common/applicationManage';

export default {
  name: 'BannerManage',
  data() {
    const self = this;
    const validatePass = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('手机视频图片不能为空'));
      } else {
        callback();
      }
    };
    const validatePassPC = (rule, value, callback) => {
      console.log(self);
      if (!value) {
        callback(new Error('PC视频图片不能为空'));
      } else {
        callback();
      }
    };
    return {
      current: 1,
      ajaxLoading: false,
      videoLoading: false,
      uploadHeader: {},
      // 弹框标题
      handleTitle: 'add',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false, // 学生详情
        // 详情
        dialogDetailVisible: false // 详情标识
      },
      dialogPlay: false,
      id: '',
      videoImg: '',
      videoImgList: [],
      dvdPcImgUrlList: [],
      dvdPcImgUrl: '',
      videoUrl: '',
      dateValue: '',
      // 搜索表单
      searchForm: {
        dateValue: '',
        videoName: '',
        videoType: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      // 操作表单
      handleForm: {
        type: 'add',
        videoName: '',
        videoNumber: '',
        videoType: 1,
        videoImg: '', // 手机
        dvdPcImgUrl: '', // PC
        videoUrl: '',
        dvdPcImgFormat: '',
        dvdPcImgSize: ''
      },
      handleDialog: {
        type: 'add'
      },
      handleRules: {
        videoName: [{ required: true, message: '视频名称不能为空', trigger: 'blur' }],
        videoNumber: [{ required: true, message: '视频编号不能为空', trigger: 'blur' }],
        videoImg: [{ required: true, validator: validatePass, trigger: 'change' }],
        dvdPcImgUrl: [{ required: true, validator: validatePassPC, trigger: 'change' }],
        videoUrl: [{ required: true, message: '视频不能为空', trigger: 'change' }],
        videoType: [{ required: true, message: '视频类型不能为空', trigger: 'change' }]
      },
      listLoading: false, // 表格刷新loading
      videoList: [],
      issueStatus: 1,
      videoTypeArr: []
    };
  },
  computed: {
    // 获取上传图片地址
    ...mapGetters(['uploadUrl', 'currentProdeuctId'])
  },
  watch: {
    handleForm(val) {
      console.log(val);
    }
  },
  mounted() {
    this.videoTypeList();
    this.getInfo();
  },
  methods: {
    // 获取分类
    videoTypeList() {
      getVideoType().then(res => {
        if (res.data && res.data.length > 0) {
          this.videoTypeArr = res.data;
        } else {
          this.videoTypeArr = [];
        }
      });
    },
    handleClickItem() {
      // 获取遮罩层dom
      setTimeout(function() {
        const domImageMask = document.querySelector('.el-image-viewer__wrapper');
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener('click', (e) => {
          if (e.target.parentNode.className === 'el-image-viewer__actions__inner') {
            return; // 如果点击底部菜单，不关闭
          }
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click();
        });
      }, 300);
    },
    close() {
      this.dialogPlay = false;
      document.getElementById('videoPlay').pause();
    },
    playVideo() {
      if (this.videoUrl.length < 1) return;
      this.dialogPlay = true;
    },
    checkoutStatus(e) {
      this.current = e;
      this.issueStatus = e;
      this.getInfo();
    },
    // 获取列表
    getInfo() {
      var option = {
        issueStatus: this.issueStatus,
        dvdName: this.searchForm.videoName,
        queryDate: this.dateValue,
        dvdType: this.searchForm.videoType,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      getVideoList(option)
        .then((res) => {
          this.listLoading = false;
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.videoList = [];
            this.searchForm.total = 0;
          } else {
            this.videoList = res.data.list;
            this.searchForm.total = res.data.total;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'warning',
            message: '暂无数据'
          });
          this.listLoading = false;
          console.log(err);
        });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getInfo();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getInfo();
    },
    typeError(toLarge) {
      this.videoLoading = false;
      if (toLarge) {
        this.$message({
          type: 'error',
          message: '只允许上传小于500M的视频文件！'
        });
      } else {
        this.$message({
          type: 'error',
          message: '只允许上传.mp4类型视频文件！'
        });
      }
    },
    clearValidate(formName) {
      this.$refs[formName].clearValidate();
    },
    uploadSucessFn(val) {
      var dvdImgFormat = val.file.name.substring(val.file.name.lastIndexOf('.') + 1);
      this.handleForm.dvdImgFormat = dvdImgFormat;
      this.videoImg = val.absolutePath;
      this.videoImgList = [val.absolutePath];
      this.handleForm.videoImg = val.absolutePath;
      this.clearValidate('videoImg');
    },
    uploadSucessFnPC(val) {
      var dvdImgFormat = val.file.name.substring(val.file.name.lastIndexOf('.') + 1);
      this.handleForm.dvdPcImgFormat = dvdImgFormat;
      this.dvdPcImgUrl = val.absolutePath;
      this.dvdPcImgUrlList = [val.absolutePath];
      this.handleForm.dvdPcImgUrl = val.absolutePath;
      this.clearValidate('dvdPcImgUrl');
    },
    imgSize(val) {
      this.handleForm.dvdImgSize = val.width.toString() + '*' + val.height.toString() + 'px';
    },
    imgSizePC(val) {
      this.handleForm.dvdPcImgSize = val.width.toString() + '*' + val.height.toString() + 'px';
    },
    progress() {
      this.videoLoading = true;
    },
    uploadVideo(val) {
      this.videoUrl = val.absolutePath;
      this.handleForm.videoUrl = val.absolutePath;
      var dvdFormat = val.file.name.substring(val.file.name.lastIndexOf('.') + 1);
      this.handleForm.dvdFormat = dvdFormat;
      this.videoLoading = false;
      this.handleForm.dvdSize = (val.file.size / (1024 * 1000)).toFixed(1) + 'MB';
      this.clearValidate('videoUrl');
    },
    // 条件查询
    handleSearchFilter(val) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.listLoading = true;
      this.getInfo();
    },
    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      this.ajaxLoading = false;
      this.handleTitle = type === 'add' ? '添加视频' : '编辑视频';
      this.handleDialog.type = type;
      this.hiddenVariable.dialogEditVisible = true;
      if (type === 'edit') {
        console.log(row);
        this.id = row.id;
        this.videoUrl = row.dvdCover;
        this.videoImg = row.dvdImgUrl;
        this.videoImgList = [row.dvdImgUrl];
        this.dvdPcImgUrl = row.dvdPcImgUrl;
        this.dvdPcImgUrlList = [row.dvdPcImgUrl];
        this.handleForm = {
          videoUrl: row.dvdCover, // 视频URL
          videoImg: row.dvdImgUrl, // 视频封面URL
          videoName: row.dvdName, // 视频名称
          videoNumber: row.dvdNo, // 视频编号
          videoType: row.dvdType, // 视频类型
          dvdPcImgUrl: row.dvdPcImgUrl // PC封面
        };
      } else {
        this.videoUrl = '';
        this.videoImg = '';
        this.dvdPcImgUrl = '';
        this.handleForm = {
          videoUrl: '',
          videoImg: '',
          dvdPcImgUrl: '',
          videoName: '',
          videoNumber: '',
          dvdType: '',
          dvdPcImgFormat: '',
          dvdPcImgSize: ''
        };
      }
    },
    // 发布
    handlePublish(type, row) {
      var status = type === 'up' ? 1 : 2;
      var text = type === 'up' ? '发布' : '下线';
      this.$confirm(`确定要${text}该视频么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const form = {
            issueStatus: status
          };
          return getVideoEdit(form, row.id);
        })
        .then((res) => {
          this.$notify.success({
            title: 'Success',
            message: `${text}成功`,
            showClose: false,
            duration: 2000
          });
          this.getInfo();
        })
        .catch(() => {});
    },
    // 新增视频
    handleAddSubject() {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          var data = {
            dvdCover: this.handleForm.videoUrl, // 视频URL
            dvdFormat: this.handleForm.dvdFormat, // 视频格式
            dvdImgFormat: this.handleForm.dvdImgFormat, // 视频封面格式
            dvdImgSize: this.handleForm.dvdImgSize, // 视频封面大小
            // dvdPcImgFormat: this.handleForm.dvdPcImgFormat, // 视频封面格式PC
            // dvdPcImgSize: this.handleForm.dvdPcImgSize, // 视频封面大小PC
            dvdImgUrl: this.videoImg, // 视频封面URL
            dvdName: this.handleForm.videoName, // 视频名称
            dvdNo: parseInt(this.handleForm.videoNumber), // 视频编号
            dvdSize: this.handleForm.dvdSize, // 视频大小
            dvdType: this.handleForm.videoType,
            // dvdType: 1, // 视频类型
            // dvdPcImgUrl: this.handleForm.dvdPcImgUrl, // PC封面
            issueStatus: 1,
            status: 1
          };
          if (this.handleDialog.type === 'add') {
            getVideoAdd(data)
              .then((res) => {
                this.hiddenVariable.dialogEditVisible = false;
                this.listLoading = true;
                this.getInfo();
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              })
              .catch(() => {
                this.ajaxLoading = false;
              });
          } else {
            getVideoEdit(data, this.id)
              .then((res) => {
                this.hiddenVariable.dialogEditVisible = false;
                this.listLoading = true;
                this.getInfo();
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              })
              .catch(() => {
                this.ajaxLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleDdelete(row) {
      this.$confirm(`确定要删除该条视频么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          getVideoDelete(row.id).then((res) => {
            if (res.code === '0') {
              this.listLoading = true;
              this.getInfo();
            }
          });
        })
        .catch(() => {});
    },
    handleClose() {
      this.videoLoading = false;
      this.handleForm = {};
      this.hiddenVariable.dialogEditVisible = false;
      this.getInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
.bannerManage {
  padding-bottom: 20px;
}
.edit-form-input {
  width: 150px;
}
.handle-form-input {
  width: 80%;
}

.upload-picture {
  text-align: right;
  // float: right;
}
.linkurl {
  cursor: pointer;
  &:hover {
    color: #1890ff;
  }
}

.upload-btn {
  width: 168px;
}
.picture-wrapper {
  width: 168px;
  height: 298px;
  margin-top: 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
.picture-wrapper .img {
  max-width: 168px;
  height: 100%;
  object-fit: scale-down;
}
.picture-wrapper video {
  width: 100%;
}
.explain {
  position: absolute;
  width: 135px;
  line-height: 1.3;
  left: 180px;
  top: 50px;
}
.btns {
  display: flex;
}
.btn {
  cursor: pointer;
  width: 78px;
  height: 35px;
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  color: #333333;
  background: #f2f2f2;
  line-height: 35px;
  text-align: center;
  margin-right: 10px;
  border: 1px #ccc solid;
}
.btn-active {
  color: #fff;
  background: #409eff;
  border: none;
}
.header-btns {
  display: flex;
  justify-content: space-between;
  margin:5px 10px 25px 10px;
}
.video {
  cursor: pointer;
}

/deep/.dialog-play .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
/deep/.dialog-play .el-dialog__body {
  padding-top: 8px;
}
/deep/.dialog-play .el-dialog__title {
  display: none;
}
/deep/ .el-icon-circle-close:before {
  color: #1890ff;
}
/deep/.dialog .el-dialog__body {
  padding-bottom: 0px;
}
.dialog-footer {
  text-align: center;
}
.footer-btn {
  width: 100px;
}
.update-ok {
  position: absolute;
  width: 200px;
  line-height: 1.3;
  left: 180px;
  top: 132px;
  color: #67c23a;
  font-size: 18px;
  animation-name: fadeInLeft;
}
</style>
